import { IdentifySupplierJobsConstants } from "../constants/IdentifySupplierJobsConstants";
import Constants from "../constants/Constants";

/**
 * region for hepers*/
const initialState = {
  pending: false,
  resultListPeding: false,
  resultListStatusPendig: false,
  page: 0,
  resultList: {},
  selectedRow: {},
  selectedRowDetails: {},
  selectedList: [],
  statusDrawer: false,
  filters: {
    domain: "",
    categories: [],
    keywords: [],
    keywordsFound: [],
    locations: [],
    supplier: null,
    idStatus: Constants.SUPPLIER_JOB_STATUS_ENUM.New,
    beginDate: "",
    endDate: "",
  },
  categoryResult: [],
  categoryResultPending: false,
  keywordsResult: [],
  keywordsResultPending: false,
  keywordsFoundResult: [],
  keywordsFoundResultPending: false,
  locations: [],
  urls: [],
  openSnackbar: false,
  typeAlert: Constants.ALERT_WARNING,
  reasonsForDiscarded: [],
  reasonsForDiscardedPending: false,
};

export default function IdentifySupplierJobsReducers(
  state = initialState,
  action
) {
  switch (action.type) {
    case IdentifySupplierJobsConstants.FETCH_IDENTIFY_SUPPLIER_JOBS_RESULT_PENDING:
      return {
        ...state,
        pending: true,
      };
    case IdentifySupplierJobsConstants.FETCH_IDENTIFY_SUPPLIER_JOBS_RESULT_ERROR:
      return {
        ...state,
        error: action.error,
        pending: false,
      };
    case IdentifySupplierJobsConstants.FETCH_IDENTIFY_SUPPLIER_JOBS_RESULT_SET_RESULT_LIST_PENDING:
      return {
        ...state,
        resultListPeding: true,
      };
    case IdentifySupplierJobsConstants.FETCH_IDENTIFY_SUPPLIER_JOBS_RESULT_GET_RESULT_LIST_SUCCESS:
      return {
        ...state,
        resultListPeding: false,
        resultList: action.payload,
      };
    case IdentifySupplierJobsConstants.FETCH_IDENTIFY_SUPPLIER_JOBS_RESULT_SET_RESULT_LIST:
      return {
        ...state,
        resultList: action.payload,
      };
    case IdentifySupplierJobsConstants.FETCH_IDENTIFY_SUPPLIER_JOBS_SET_PAGE:
      return {
        ...state,
        pending: false,
        page: action.page,
      };
    case IdentifySupplierJobsConstants.FETCH_IDENTIFY_SUPPLIER_JOBS_SET_SELECTED_LIST:
      return {
        ...state,
        pending: false,
        selectedList: action.selectedList,
      };
    case IdentifySupplierJobsConstants.FETCH_IDENTIFY_SUPPLIER_JOBS_SET_STATUS_DRAWER:
      return {
        ...state,
        pending: action.pending,
        statusDrawer: action.statusDrawer,
      };
    case IdentifySupplierJobsConstants.FETCH_IDENTIFY_SUPPLIER_JOBS_SET_SELECTED_ROW:
      return {
        ...state,
        pending: false,
        selectedRow: action.selectedRow,
        selectedRowDetails: action.selectedRowDetails,
      };
    case IdentifySupplierJobsConstants.FETCH_IDENTIFY_SUPPLIER_JOBS_SET_FILTERS:
      return {
        ...state,
        filtersPending: false,
        filters: action.filters,
        page: action.page,
      };
    case IdentifySupplierJobsConstants.FETCH_IDENTIFY_SUPPLIER_JOBS_SET_FILTERS_PENDING:
      return {
        ...state,
        filtersPending: true,
      };
    case IdentifySupplierJobsConstants.FETCH_IDENTIFY_SUPPLIER_JOBS_GET_CATEGORIES_LIST_PENDING:
      return {
        ...state,
        pending: true,
      };
    case IdentifySupplierJobsConstants.FETCH_IDENTIFY_SUPPLIER_JOBS_GET_CATEGORIES_LIST:
      return {
        ...state,
        pending: false,
        categoryResult: action.categoryResult,
      };
    case IdentifySupplierJobsConstants.FETCH_IDENTIFY_SUPPLIER_JOBS_GET_KEYWORDS_LIST_PENDING:
      return {
        ...state,
        keywordsResultPending: true,
      };
    case IdentifySupplierJobsConstants.FETCH_IDENTIFY_SUPPLIER_JOBS_GET_KEYWORDS_LIST:
      return {
        ...state,
        keywordsResultPending: false,
        keywordsResult: action.keywordsResult,
      };
    case IdentifySupplierJobsConstants.FETCH_IDENTIFY_SUPPLIER_JOBS_GET_KEYWORDS_FOUND_LIST_PENDING:
      return {
        ...state,
        keywordsFoundResultPending: true,
      };
    case IdentifySupplierJobsConstants.FETCH_IDENTIFY_SUPPLIER_JOBS_GET_KEYWORDS_FOUND_LIST:
      return {
        ...state,
        keywordsFoundResultPending: false,
        keywordsFoundResult: action.keywordsFoundResult,
      };
    case IdentifySupplierJobsConstants.FETCH_IDENTIFY_SUPPLIER_JOBS_SET_STATUS_TO_JOB_LIST_PENDING:
      return {
        ...state,
        resultListStatusPendig: true,
      };
    case IdentifySupplierJobsConstants.FETCH_IDENTIFY_SUPPLIER_JOBS_SET_STATUS_TO_JOB_LIST:
      return {
        ...state,
        resultListStatusPendig: false,
        urls: action.urls,
      };
    case IdentifySupplierJobsConstants.FETCH_IDENTIFY_SUPPLIER_JOBS_GET_LOCATIONS_LIST:
      return {
        ...state,
        locations: action.locations,
      };
    case IdentifySupplierJobsConstants.FETCH_IDENTIFY_SUPPLIER_JOBS_SET_URL_LIST:
      return {
        ...state,
        pending: false,
        urls: action.urls,
      };
    case IdentifySupplierJobsConstants.FETCH_IDENTIFY_SUPPLIER_JOBS_SET_OPEN_SNACKBAR:
      return {
        ...state,
        openSnackbar: action.openSnackbar,
        typeAlert: action.typeAlert,
      };
      case IdentifySupplierJobsConstants.FETCH_IDENTIFY_SUPPLIER_JOBS_GET_REASONSFORDISCARDED_LIST_PENDING:
        return {
          ...state,
          pending: true,
        };
      case IdentifySupplierJobsConstants.FETCH_IDENTIFY_SUPPLIER_JOBS_GET_REASONSFORDISCARDED_LIST:
        return {
          ...state,
          pending: false,
          reasonsForDiscarded: action.reasonsForDiscarded,
        };
    default:
      return state;
  }
}
